import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dayjs } from 'dayjs';

@Pipe({ name: 'ordinalDate' })
export class OrdinalDatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  daysDe = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  monthsDe = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'July',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];

  daysEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  monthsEn = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  transform(value: Dayjs): string {
    if (!value) {
      return '';
    }

    if (this.translate.currentLang === 'de') {
      return `${this.daysDe[value.day()]}, ${value.date()}. ${this.monthsDe[value.month()]} ${value.format('HH:mm:ss')}`;
    } else {
      return `${this.daysEn[value.day()]}, ${value.date()}${this.nth(value.date())} ${
        this.monthsEn[value.month()]
      } ${value.format('HH:mm:ss')}`;
    }
  }

  nth(d: number) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}
